import React from "react";

const About = () => {
  return (
    <section className="services_area pd_70">
      <div className="container">
        <div className="serce_box_outer">
          <div className="row">
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="service_item bg_white h-100 text-center">
                <div className="srvc_icon mb-3">
                  <i className="material-icons-outlined text-primary">
                    {" "}
                    language{" "}
                  </i>
                </div>
                <div className="srvc_text">
                  <h3 className="fs-xl text-primary text-uppercase mb-3">
                    The global innovation event
                  </h3>
                  <p className="text-primary fs-sm">
                    The largest entrepreneurship event that will be attended by
                    investors, venture capital, innovation centres, industry
                    associations, universities and global institutions.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="service_item bg_white h-100 text-center">
                <div className="srvc_icon mb-3">
                  <i className="material-icons-outlined text-primary">
                    {" "}
                    emoji_objects{" "}
                  </i>
                </div>
                <div className="srvc_text">
                  <h3 className="fs-xl text-primary text-uppercase mb-3">
                    More than 2000 square meters dedicated to entrepreneurship
                  </h3>
                  <p className="text-primary fs-sm">
                    The largest space for entrepreneurial innovation with a
                    mobilised investment capacity of more than 500 million
                    euros.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="service_item bg_white h-100 text-center">
                <div className="srvc_icon mb-3">
                  <i className="material-icons-outlined text-primary">
                    {" "}
                    diversity_2{" "}
                  </i>
                </div>
                <div className="srvc_text">
                  <h3 className="fs-xl text-primary text-uppercase mb-3">
                    Benchmark networking for the ecosystem
                  </h3>
                  <p className="text-primary fs-sm">
                    Business roundtables, pitch spaces, stand areas and
                    conferences that will bring together more than 100 speakers
                    from the USA, Latin America, Europe, Asia and Africa.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="service_item bg_white h-100 text-center">
                <div className="srvc_icon mb-3">
                  <i className="material-icons-outlined text-primary">
                    {" "}
                    badge{" "}
                  </i>
                </div>
                <div className="srvc_text">
                  <h3 className="fs-xl text-primary text-uppercase mb-3">
                    Endorsed by the ecosystem's top leaders
                  </h3>
                  <p className="text-primary fs-sm">
                    More than 100 personalities in an Advisory and Honorary
                    Council that brings together the main leaders of the startup
                    and innovation ecosystem
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="service_item bg_white h-100 text-center">
                <div className="srvc_icon mb-3">
                  <i className="material-icons-outlined text-primary">
                    {" "}
                    settings_voice{" "}
                  </i>
                </div>
                <div className="srvc_text">
                  <h3 className="fs-xl text-primary text-uppercase mb-3">
                    With the presence of leading media
                  </h3>
                  <p className="text-primary fs-sm">
                    El Referente, Forbes, Emprendedores, Todostartups, Soy
                    Emprendedor or Diario Latinoaméricano among others.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="service_item bg_white h-100 text-center">
                <div className="srvc_icon mb-3">
                  <i className="material-icons-outlined text-primary">
                    {" "}
                    verified{" "}
                  </i>
                </div>
                <div className="srvc_text">
                  <h3 className="fs-xl text-primary text-uppercase mb-3">
                    Industry Panels & Trends
                  </h3>
                  <p className="text-primary fs-sm">
                    A space to make innovative talent and trends visible in
                    emerging sectors such as Health, Tech, FoodTech,
                    ClimateTech, Aerospace, Agrotech, Bioeconomy, AI among
                    others
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
